import { getIsServerEnv } from '@/shared/modules/environment';

import { normalizeUrlBaseValue, normalizeUrlPathname, removePathnameSegment } from './common';

/**
 * @returns {string} For the "Server" environment is will be Server to Server `PIPELINE_BASE_URL` and
 * `window.location.origin` for the "Client"
 */
const getBaseUrlToExternalApi = () => {
  const baseUrl = getIsServerEnv() === true ? process.env.PIPELINE_BASE_URL : window.location.origin;
  return normalizeUrlBaseValue(baseUrl);
};

/**
 * @param pathname {string} should starts from '/'
 * @param resourceType {'content' | 'backend'} the type of resource we want to build a `pathname prefix` to
 * @returns {string} `pathname prefix` which may start with an optional `proxy prefix` (in which case this request will
 * be handled in "next.config" to avoid CORS errors for local development) if this request is run on a client and only
 * in `development` or `build:serve` mode (if this `process.env` will be added to the `local.env` file). For a deployed
 * project, this `pathname prefix` will be equal to the correct API pathname specified in the ENV (so the `rewrites`
 * section in "next.config" will be omitted)
 */
const getPathnamePrefixByResourceType = (resourceType: 'content' | 'backend') => {
  const pathnamePrefixByType = normalizeUrlPathname(
    resourceType === 'content'
      ? process.env.NEXT_PUBLIC_PATHNAME_PREFIX_TO_CONTENT_API
      : process.env.NEXT_PUBLIC_PATHNAME_PREFIX_TO_BACKEND_API,
  );

  return getIsServerEnv() === true
    ? normalizeUrlPathname(removePathnameSegment(pathnamePrefixByType, process.env.NEXT_PUBLIC_PROXY_PREFIX))
    : pathnamePrefixByType;
};

/**
 * @param pathname {string} should starts from '/'
 */
export const getUrlToContentApi = (pathname: string) => {
  const normalizedPathname = normalizeUrlPathname(pathname);
  const pathnamePrefix = getPathnamePrefixByResourceType('content');
  return new URL(normalizeUrlPathname(`${pathnamePrefix}${normalizedPathname}`), getBaseUrlToExternalApi());
};

/**
 * @param pathname {string} should starts from '/'
 */
export const getUrlToBackendApi = (pathname: string) => {
  const normalizedPathname = normalizeUrlPathname(pathname);
  const pathnamePrefix = getPathnamePrefixByResourceType('backend');
  return new URL(normalizeUrlPathname(`${pathnamePrefix}${normalizedPathname}`), getBaseUrlToExternalApi());
};
